import { render, staticRenderFns } from "./LoginRegistered.vue?vue&type=template&id=29f62db2&scoped=true"
import script from "./LoginRegistered.vue?vue&type=script&lang=js"
export * from "./LoginRegistered.vue?vue&type=script&lang=js"
import style0 from "./LoginRegistered.vue?vue&type=style&index=0&id=29f62db2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f62db2",
  null
  
)

export default component.exports